// extracted by mini-css-extract-plugin
export default {"toggleButton":"ToggleButton_toggleButton__q9pEQ","active":"ToggleButton_active__jMdWs","disabled":"ToggleButton_disabled__IheHL","toggleBall":"ToggleButton_toggleBall__Qm7nU"};